/**
 * Accordion panel
 * 
 * Same functionality as a button accordion,
 * but allows for the button and content elements to be 
 * placed in separate containers. 
 */

class AccordionPanel {
  constructor(btn) {
    this.btn = btn;
    this.panel = document.getElementById(btn.dataset.accordionPanel);
    if (!this.panel) return;
    this.btn.addEventListener('click', () => this.toggle());

    this.panel.querySelectorAll('.close-button[data-close]').forEach(closeBtn => {
      closeBtn.addEventListener('click', () => this.close());
    });
  }

  close() {
    this.panel.style.maxHeight = '0';
    this.panel.setAttribute('aria-expanded', 'false');
    this.btn.setAttribute('aria-expanded', 'false');
  }

  toggle() {
    const isOpen = this.btn.getAttribute('aria-expanded') === 'true';
    this.panel.style.maxHeight = isOpen ? '0' : this.panel.scrollHeight + 'px';
    this.panel.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    this.btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
  }
}

function initAccordionPanels(selector = '[data-accordion-panel]') {
  document.querySelectorAll(selector).forEach(btn => new AccordionPanel(btn));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initAccordionPanels());
} else {
  initAccordionPanels();
}

export { AccordionPanel, initAccordionPanels };
